var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotal({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "175.78125px",
    height: "175.781251px",
    viewBox: "0 0 175.78125 175.781251",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,87.890625 C0,119.290921 16.7518579,148.305992 43.9453121,164.00614 C71.1387663,179.706288 104.642484,179.706288 131.835938,164.00614 C159.029392,148.305992 175.78125,119.290921 175.78125,87.890625 C175.78125,39.3499732 136.431277,0 87.890625,0 C39.3499732,0 0,39.3499732 0,87.890625 Z",
    fill: "#B2E4C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3203125,46.1328125 L83.1445313,46.1328125 C57.7929688,46.1328125 37.2265625,66.6992187 37.2265625,92.0507812 C37.2265625,117.402344 57.7929688,137.96875 83.1445313,137.96875 C108.457031,137.96875 128.984375,117.5 129.0625,92.2070312 L83.3203125,92.2070312 L83.3203125,46.1328125 Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6367188,37.8125 L92.4414063,37.8125 L92.4414063,83.59375 L138.554688,83.59375 C138.476563,58.3007812 117.949219,37.8125 92.6367188,37.8125 L92.6367188,37.8125 Z",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotal);
export default __webpack_public_path__ + "static/media/total.b7dec1191823030776cb05cf79d69e9f.svg";
export { ForwardRef as ReactComponent };